const perf=[
// {   i:1,
//     id:1,
//     habilitado:false,
//     fecha:"25/08/2021",
//     nombrePerfil:"Seguridad",
//     descripcion:"Permite la gestión de usuarios y productos asociados a estos"
//     value:""

// },
// {
    
//     id:1,
//     habilitado:false,
//     fecha:"25/08/2021",
//     nombrePerfil:"Seguridad",
//     descripcion:"Permite ejecutar operaciones todos los módulos",
//     value:"1111"
// },

{
    
    id:2,
    habilitado:false,
    fecha:"30/06/2022",
    nombrePerfil:"Consulta",
    descripcion:"Solo permite consultar en los módulos",
    value:"0000"
}
,
{
    
    id:3,
    habilitado:false,
    fecha:"30/06/2022",
    nombrePerfil:"Preparador",
    descripcion:"Solo permite hacer cargue masivos",
    value:"0100"
},
{
    
    id:4,
    habilitado:false,
    fecha:"30/06/2022",
    nombrePerfil:"Estándar",
    descripcion:"Permite hacer y aprobar cargue masivos",
    value:"0101"
},
{
    
    id:5,
    habilitado:false,
    fecha:"30/06/2022",
    nombrePerfil:"Aprobador",
    descripcion:"Solo permite autorizar cargues masivos",
    value:"0001"
}
]


module.exports=perf;